import { DragDropContext, Droppable, type DropResult } from '@hello-pangea/dnd';
import { type CSSProperties, type FC, type ReactNode, useCallback } from 'react';

interface SortableListProps {
  droppableId: string;
  onReorder: (sourceIndex: number, destinationIndex: number) => void;
  disabled?: boolean;
  className?: string;
  style?: CSSProperties;
  children: ReactNode;
}

const SortableList: FC<SortableListProps> = ({ droppableId, onReorder, disabled, className, style, children }) => {
  const handleDragEnd = useCallback(
    (result: DropResult) => {
      if (disabled === true) {
        return;
      }
      if (
        !result.destination ||
        result.source.index === result.destination.index ||
        result.destination.droppableId !== droppableId
      ) {
        return;
      }
      onReorder(result.source.index, result.destination.index);
    },
    [disabled, droppableId, onReorder]
  );

  const onDragEnd = disabled === true ? () => {} : handleDragEnd;

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId={droppableId} isDropDisabled={disabled === true}>
        {(provided) => (
          <div ref={provided.innerRef} {...provided.droppableProps} className={className} style={style}>
            {children}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
};

export default SortableList;
